var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpicWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 420 180",
    preserveAspectRatio: "none",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M0 90C60 40 120 20 210 55C300 90 360 70 420 45V180H0V90Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B2B",
    opacity: 0.6,
    d: "M0 120C80 85 150 75 240 95C330 115 380 100 420 85V180H0V120Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078F2",
    opacity: 0.18,
    d: "M0 145C90 125 180 115 280 130C350 140 390 135 420 128V180H0V145Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpicWave);
export default __webpack_public_path__ + "static/media/epic-wave.7a260acb870fc1286e33b74c5642a241.svg";
export { ForwardRef as ReactComponent };